import {
  DELETE_PROPOSE_NOTICE, DELETE_PROPOSE_NOTICE_SUCCESS, DELETE_PROPOSE_NOTICE_FAILURE
} from './mutation-types'

export default {
  actions: {
    [DELETE_PROPOSE_NOTICE] ({dispatch, state, commit}, params = null) {
      var url = `/asovi/propose_notices/${params.id}`
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DELETE_PROPOSE_NOTICE_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(DELETE_PROPOSE_NOTICE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [DELETE_PROPOSE_NOTICE_FAILURE] (state, data) {
      console.log('DELETE_PROPOSE_NOTICE_FAILURE')
    },
    [DELETE_PROPOSE_NOTICE_SUCCESS] (state, data) {
      console.log('DELETE_PROPOSE_NOTICE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-notice.js